import Vue from 'vue';
import Router from 'vue-router';
import config from 'config';

import BimDetail from '@/pages/bim/detail';
import ProjectDetail from '@/pages/project/detail';

Vue.use(Router);

const routerInstance = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/bim/detail/:id',
      name: 'bim-detail',
      component: BimDetail,
      meta: {
        title: '构件详情',
      },
    },
    {
      path: '/project/detail/:id',
      name: 'project-detail',
      component: ProjectDetail,
      meta: {
        title: '项目详情',
      },
    },
  ],
});

/* 设置页面title */
routerInstance.beforeEach((to, from, next) => {
  document.title = !!to.meta.title ? to.meta.title : config.DEFAULT_PAGE_TITLE;

  next();
});

export default routerInstance;



// WEBPACK FOOTER //
// ./src/router/index.js